/** @jsx jsx */
import { jsx } from "@emotion/react";
import { Icon } from "@material-ui/core";
import noop from "lodash/fp/noop";
import { FC } from "react";
import { Link } from "react-router-dom";

import ToggleStar from "src/components/atoms/inputs/ToggleStar";
import { useIsMobile } from "src/hooks/viewport/useViewportCategory";
import { setPrimaryAsColor } from "../../../../../../assets/styles/styles";
import { IconName, LinkTo, TemplateId } from "../../../../../../globalTypes";
import { OverviewTemplateRouteState } from "../../../../../../utils/internalLinksParsing";
import TemplateInfoTooltip from "../../../../../atoms/TemplateInfoTooltip";
import { SecondaryColorLabel } from "../../sharedStyles";
import {
  ArrowIconModule,
  infoButtonCss,
  innerContainerCss,
  labelPaddingCss,
  LabelWrapper,
  NotificationIndicatorModule,
  outerContainerCss,
  ToggleStarModule,
} from "./styles";

const TemplateCardModuleView: FC<Props> = ({
  templateId,
  label,
  linkTo,
  onClick = noop,
  isFavourite,
  toggleFavourite,
  icon,
  description,
}) => {
  const isMobile = useIsMobile();

  return (
    <div css={outerContainerCss} data-cy="template-view-module-link">
      <Link
        onClick={onClick}
        to={linkTo as LinkTo<unknown>} // Je třeba castovat state na unknown kvůli typing chybě v react-router-dom
        css={innerContainerCss}
      >
        <LabelWrapper>
          <Icon css={setPrimaryAsColor}>{icon}</Icon>
          <SecondaryColorLabel css={labelPaddingCss(isMobile)} marginLeft>
            {label}
          </SecondaryColorLabel>
        </LabelWrapper>

        <ArrowIconModule />
      </Link>

      {description && (
        <div css={infoButtonCss}>
          <TemplateInfoTooltip tooltipText={description} />
        </div>
      )}

      <ToggleStarModule>
        <ToggleStar active={isFavourite} onClick={toggleFavourite} />
      </ToggleStarModule>

      <NotificationIndicatorModule templateId={templateId} onClick={onClick} />
    </div>
  );
};

type Props = {
  templateId: TemplateId;

  label: string;
  isFavourite: boolean;
  icon: IconName;
  description: string | null;

  linkTo?: LinkTo<OverviewTemplateRouteState>;

  onClick?: () => void;
  toggleFavourite: () => void;
};

export type TemplateCardModuleViewProps = Props;
export default TemplateCardModuleView;
